import importerSelectors from 'src/modules/shared/importer/importerSelectors';

const habilidadImporterSelectors = importerSelectors(
  'habilidad.importer',
);

export default habilidadImporterSelectors;
